import {
  CurecallCopyButton,
  CurecallButton,
  CurecallTooltip,
  ECurecallButtonAppearance,
} from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { TModalProps } from './users-table.component'

export type Props = {
  modalProps: TModalProps
  setModalProps: (modalProps: TModalProps) => void
}

export default function UserProjectSummary({ modalProps, setModalProps }: Readonly<Props>) {
  const { t } = useTranslation()

  const userCredentials =
    modalProps?.mode === 'SUMMARY'
      ? {
          email: modalProps.UserProject.User?.email,
          temporaryPassword: modalProps.password,
        }
      : undefined

  return (
    <div className="c-flex c-flex-col c-gap-8">
      <div className="c-flex c-flex-col c-gap-4 [&_p]:c-m-0">
        <div className="c-flex c-items-center c-justify-between">
          {}
          <span className="c-font-bold">{t('pages.users-page.summary-sub')} :</span>
          <CurecallTooltip tooltipPosition="bottom-end" content={t('pages.users-page.tooltip-copy')}>
            <CurecallCopyButton ariaLabelText="copy" data={userCredentials?.temporaryPassword ?? ''} />
          </CurecallTooltip>
        </div>
        <div className="c-flex c-flex-col c-items-center c-gap-2 c-my-3">
          <p>{t('pages.users-page.summary-email', { userEmail: userCredentials?.email })}</p>
          <p>
            {t('pages.users-page.summary-password')}
            <span className="c-font-bold c-pl-2">{userCredentials?.temporaryPassword}</span>
          </p>
        </div>
        <p className="c-text-grey-600">{t('pages.users-page.summary-description')}</p>
      </div>
      <CurecallButton
        appearance={ECurecallButtonAppearance.SECONDARY}
        className="c-mx-auto"
        onClick={() => setModalProps(undefined)}
      >
        {t('pages.users-page.cta-terminate')}
      </CurecallButton>
    </div>
  )
}
